import { isNil, omitBy } from 'lodash';

export const WIDGET_NAME = 'set_funding_account';

export interface FundingAccountState {
  routingNumber: string;
  achName: string;
  radioSelected: string | null | undefined;
  accountNumber: string;
  validateAccountNumber: string;
}

export interface BaseFundingAccountProps {
  fundingSource: string | null;
  setFundingSource: (type: string | null) => void;
  getInitialFundingAmount: () => number;
  submitPaymentMethod: (accountDetails: any, callback: any) => void;
}

export type BillingAddressProps = {
  streetAddress?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
};

export function convertApplePayBillingAddressToAddress(
  address?: ApplePayJS.ApplePayPaymentContact
): BillingAddressProps {
  const addressLines = address?.addressLines;
  return omitBy(
    {
      streetAddress:
        addressLines && addressLines.length > 0 ? addressLines[0] : undefined,
      streetAddress2:
        addressLines && addressLines.length > 1 ? addressLines[1] : undefined,
      city: address?.locality,
      state: address?.administrativeArea,
      postalCode: address?.postalCode
    },
    isNil
  );
}

export function convertGooglePayBillingAddressToAddress(
  address?: google.payments.api.Address
): BillingAddressProps {
  return omitBy(
    {
      streetAddress: address?.address1,
      streetAddress2: address?.address2,
      city: address?.locality,
      state: address?.administrativeArea,
      postalCode: address?.postalCode
    },
    isNil
  );
}
